import QuestionsTable from './QuestionsTable';

export default QuestionsTable;
